
import React from 'react';
import { ContactUsBanner } from './modules/ContactUsBanner';
import DropDown from './modules/DropDown';
import ModalDialog from './modules/Popup';
import NBA from './modules/NBA';
import { MS_LOCATION, CONTACT_US_PAGE_CATEGORY, CONTACT_US_PAGE_SUBCATEGORY } from '../constants/constants';
import '../assets/css/contactus.css';
import '../assets/css/banner.css';
import { RTCICall, MetricRTCICall } from "./modules/RTCICall";
import { getOS, isNullOrUndefined, updateUserID, RemoveHeaderHiddenClass } from "./modules/CommonFunctions";
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import { Chat } from "./modules/IncludeChat";
import CovidAlert from './modules/CovidAlert';
import { Header } from './modules/HeaderContent';
import { Footer } from './modules/FooterContent';
import {setNativeTitleWithNavigation,nativeHideTopBar,nativeUpdateFab, nativeSmartLinkToExternalBrowser} from "../actions/native";

class ContactUsCallMePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scheduleCall: false
        }
        this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
        this.dialogStyle = (this.isMobile) ? { "top": "50%", "position": "fixed", "transform": "translate(-40%, -45%)" } : { "top": "50%", "position": "fixed", "transform": "translate(20%, -45%)" }
        this.errorElement = "";
        this.autoCompleteRef = React.createRef();
        this.inputRef = React.createRef();
        this.dialogRef = React.createRef();
        this.conformJSON = {};
        this.phoneNumbers = [];
        this.dialogContent = "<span>We cannot process your request at this time.</span><p>For additional assistance, call 1-800-VERIZON (1-800-837-4966).</p>";
        this.conformData = "";
        this.scheduledTime = "";
        this.successHeader = "Thank you";
        this.failureHeader = "We're sorry";
        this.meridian = "";
        this.pasteActionHandler = this.onPasteValue.bind(this);
        this.isValidUser = false;
        if(window.userinfo !== null && window.userinfo !== undefined) {this.isValidUser = true;}
        this.pegaID = (this.isValidUser && !isNullOrUndefined(window.contactUsDynamicData.Attribute) && !isNullOrUndefined(window.contactUsDynamicData.Attribute.content)) ? window.contactUsDynamicData.Attribute.content : "";
        this.topicValue = "";
        this.subTopicValue = "";
        this.timeValue = "";
        this.metricsArgs = {
            os: getOS(),
            category: CONTACT_US_PAGE_CATEGORY,
            subCategory: CONTACT_US_PAGE_SUBCATEGORY,
            pegaSessionID: this.pegaID,
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        }
        this.BTN = "";
        this.getECRMData();
        this.IsOneApp = false;
        if(window.oneAppFlag == true && window.oneAppFlag != null){
            this.IsOneApp = "";
             this.IsOneApp = true;            
        }

    }

    navigateBack() {
        window.location.href = window.location.href.substring(0, window.location.href.indexOf('callme') - 1)
    }

    updateDialogContent(content, header) {
        this.dialogRef.current.querySelector('.modal_header .heading').innerHTML = header;
        this.dialogRef.current.querySelector('.modal_content .padding-vert-small').innerHTML = content;
        this.dialogRef.current.classList.add('active');
        this.dialogRef.current.classList.remove('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.add('active');
        document.getElementsByClassName('page-overlay')[0].classList.remove('hide_dialog');
        this.dialogRef.current.querySelector('.modal_x').focus();
    }


    toggleCheckBox(e) {
        if (e && e.target !== undefined) {
            if (!e.target.classList.contains('checked')) {
                let id = e.target.getAttribute('for');
                e.target.parentElement.querySelector("#" + id).checked = true;
                let prevItem = document.querySelector('.checked').getAttribute('for');
                document.querySelector('#' + prevItem).checked = false;
                document.querySelector('.checked').classList.remove('checked');
                e.target.classList.add('checked');
                this.BTN = !isNullOrUndefined(e.target.innerText) ? e.target.innerText : "";
                this.inputRef.current.value = '';
            }
            if (document.querySelector('.custom_checkbox').checked) {
                this.validateCheckBox(document.querySelector('.custom-phone-input'));
            }
        } else {
            this.BTN = this.phoneNumbers[0] ? this.phoneNumbers[0] : this.inputRef.current.value;
        }
    }


    enableConfirmButton(e) {
        document.querySelector("#callmeButton").classList.remove('disabled');
    }

    updateErrorElement() {
        this.errorElement = document.querySelector('.error');
    }

    handleConfirmCall(e) {
        if (e.keyCode === 13) {
            this.scheduleCall();
        }
    }

    scheduleCall() {
        if (this.BTN === "") {
            if (!document.querySelector('.custom_checkbox').checked) {
                this.BTN = this.phoneNumbers[0] ? this.phoneNumbers[0] : this.validatePhoneNumber();
            } else {
                this.validatePhoneNumber();
                return;
            }
        }

        document.querySelector('.hide_spinner').classList.add('show_spinner');
        let localInstance = this;
        if (this.timeValue !== "" && !isNullOrUndefined(this.timeValue)) {
            //  window.scLinkTrackID("confirm- " + this.timeValue + " " + this.topicValue + ": " + this.subTopicValue);
        } else {
            //  window.scLinkTrackID("confirm- " + this.topicValue + ": " + this.subTopicValue);
        }
        fetch(MS_LOCATION + "/callme/register", {
            method: "POST",
            headers: new Headers({
                'content-type': 'application/json'
            }),
            body: JSON.stringify(localInstance.conformJSON)
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            if (document.querySelector('.show_spinner') !== null) {
                document.querySelector('.show_spinner').classList.remove('show_spinner');
            }
            if (json.VZCBResponse !== undefined && json.VZCBResponse !== null && json.VZCBResponse.Body.RegisterCallbackResponse.StatusCode === 0) {
                if (document.querySelector('.ddl3') !== null && document.querySelector('.ddl3') !== undefined) {
                    let selectedDate = document.querySelector('.ddl3 .text').innerText;
                    selectedDate = (selectedDate.indexOf('today') > -1) ? "Today, " + localInstance.scheduledTime + " " + localInstance.meridian : (selectedDate.indexOf('Tomorrow') > -1) ? "Tomorrow, " + localInstance.scheduledTime + " " + localInstance.meridian : "as soon as an agent is available";
                    let dialogContent = "<span id='regcbcontP'>Your call is scheduled for: </span><h5 class='heading' id='regcbcont'>" + selectedDate + "</h5><p id='regcbcontNP'>Please remember times are approximate and may vary according to agent availability.</p>";
                    localInstance.updateDialogContent(dialogContent, localInstance.successHeader);
                } else {
                    let dialogContent = "<span id='regcbcontP'>Your call is scheduled for: </span><h5 class='heading' id='regcbcont'>Today, as soon as an agent is available</h5><p id='regcbcontNP'>Please remember times are approximate and may vary according to agent availability.</p>";
                    localInstance.updateDialogContent(dialogContent, localInstance.successHeader);
                }

            } else {
                localInstance.updateDialogContent(localInstance.dialogContent, localInstance.failureHeader);
            }
        }).catch(function (e) {
            if (document.querySelector('.show_spinner') !== null) {
                document.querySelector('.show_spinner').classList.remove('show_spinner');
            }
            localInstance.updateDialogContent(localInstance.dialogContent, localInstance.failureHeader);
        })

    }

    updateData(topic, supTopic, time, GID, meridian, priority) {
        this.scheduledTime = time;
        this.meridian = meridian;
        this.topicValue = topic;
        this.subTopicValue = supTopic;
        this.timeValue = time;
        this.conformJSON = {
            "VZCBRequest": {
                "Header": {
                    "ClientName": "MYFIOS",
                    "ClientIP": "68.134.166.232",
                    "TransactionID": -549845223,
                    "RequestName": "RegisterCallback"
                },
                "Body": {
                    "RegisterCallbackRequest": {
                        "GlobalSessionID": GID,
                        "Topic": topic,
                        "SubTopic": supTopic,
                        "CBType": priority,
                        "CBR": this.BTN.replace(/[^0-9]/g, ''),
                        "QueueName": "NewCustSales_Online",
                        "SelectedSlot": time,
                        "CustomerID": window.userinfo.details.vcustid,
                        "Authenticated": 1,
                        "ACCOUNT_ID": window.userinfo.visionId + window.userinfo.visionAcctId,
                        "ACCOUNT_TYPE": "VISION",
                        "BTN": {}
                    }
                }
            }
        }
    }

    validateCheckBox(input) {
        this.updateErrorElement();
        if (input.value.length < 10) {
            if (input.value.length === 0 && document.querySelector('.custom_checkbox').checked) {
                this.errorElement.classList.add('validated');
                this.errorElement.innerText = "Please enter a valid 10 digit phone number";
            } else if (input.value.length === 0 && !document.querySelector('.custom_checkbox').checked) {
                console.log('No Error');
                this.errorElement.classList.remove('validated');
            }

        } else {
            this.errorElement.classList.remove('validated');
        }
        if (input.value.length === 10) {
            const checkSameVal = input.value.split('').every(function (value) {
                return value === input.value[0];
            })
            if (checkSameVal) {
                this.errorElement.innerText = "All digits are same, Please check."
                this.errorElement.classList.add('validated');
            }
        }
        if (!isNullOrUndefined(document.querySelector('.checked')) && !isNullOrUndefined(document.querySelector('.checked').getAttribute('for')) &&
            !isNullOrUndefined(document.querySelector("#" + document.querySelector('.checked').getAttribute('for')))) {
            document.querySelector("#" + document.querySelector('.checked').getAttribute('for')).checked = false;
        }
        document.getElementsByClassName('custom_checkbox')[0].checked = true;
    }

    validatePhoneNumber() {
        this.validateCheckBox(this.inputRef.current);
        this.BTN = (this.errorElement.classList.contains('validated')) ? "" : document.querySelector('#custom_number').value;
    }

    validateOnKeyUp(e) {
        this.updateErrorElement();
        if (this.errorElement.classList.contains('validated') && e.target.value.length === 10) {
            this.errorElement.classList.remove('validated');
        }
    }

    validateOnKeyDown(e) {
        if (e.target.value.length === 10 && e.keyCode !== 8 && e.keyCode !== 46) {
            e.preventDefault();
        } if (e.keyCode === 9) {
            setTimeout(() => {
                document.querySelector('.ddl1').focus();
                document.querySelector('.ddl1').classList.add('keyboard_focus');
            }, 100);
        }
    }

    loadLocalImage(name) {
        let imagePath;
        if (name === "callme") {
            imagePath = "/content/dam/verizon/support/consumer/supportservices/vcm-react/media/call-icon.svg";
        } else if (name === "chatnow") {
            imagePath = "/content/dam/verizon/support/consumer/supportservices/vcm-react/media/contact-chat-icon.svg";
        } else if (name === "messageus") {
            imagePath = "/content/dam/verizon/support/consumer/supportservices/vcm-react/media/fbmessage.png";
        }
        return imagePath;
    }

    closeDialog(e) {
        if (!isNullOrUndefined(e.keyCode) && (e.keyCode !== 13 && e.keyCode !== 27)) {
            return;
        }
        this.dialogRef.current.classList.add('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.add('hide_dialog');
        document.getElementsByClassName('page-overlay')[0].classList.remove('active');
        this.dialogRef.current.classList.remove('active');
        document.querySelector('.hide_spinner').classList.add('show_spinner');
        //let navpath ="/support/"+window.domain_url+"/contact-us";
        //window.location.href = navpath;
        const IsFiosFlag = localStorage.getItem('IsFiosOnlyFlag');//CXTDT-250100
        // if(IsFiosFlag == 'true'){           
        //     window.location.href = window.location.href.substring(0, window.location.href.indexOf('callme') - 1) +"/contactuslanding.htm?src=FiosOnly";           
        // }else{           
        //   window.location.href = window.location.href.substring(0, window.location.href.indexOf('callme') - 1)
        // }
        window.history.back();
    }


    componentDidMount() {
        updateUserID();
        //   window.constructScData('urlPageLoad','');
        if(window.oneAppFlag == true && window.oneAppFlag != null){
          nativeHideTopBar(true);
        }
        let operatingSystem = getOS();
        let intent = "";
        let nbaCount = 0;
        if (window.contactUsDynamicData != null && window.contactUsDynamicData.resourcesummary != null) {
            for (let i = 0; i < window.contactUsDynamicData.resourcesummary.length; i++) {
                intent = window.contactUsDynamicData.resourcesummary[i].resourceid;
                let appChannelValue = "";
                let intentlowercase = "";
                intentlowercase = intent.toLowerCase();
                var intentArray = ["ppsh_generic_biml_lowermybill", "ppsh_generic_piml_manageautopay", "ppsh_generic_biml_pmt_arrng",
                                    "ppsh_generic_autopay_cnf","ppsh_generic_outage_ipr"];
                if(intentArray.indexOf(intentlowercase)!== -1)  {
                    //value exists
                    appChannelValue = "ESUPPORT";
                }  
                else{
                    appChannelValue = "NBA-ESUPPORT";
                }               
                // if(intent == "PPSH_Generic_BIML_Lowermybill" || intent == "PPSH_Generic_PIML_Manageautopay" || 
                //     intent == "PPSH_Generic_Biml_PMT_Arrng" || intent == "PPSH_Generic_Autopay_CNF" ||
                //     intent == "PPSH_GENERIC_OUTAGE_IPR"){
                //     appChannelValue = "ESUPPORT";
                // }
                // else{
                //     appChannelValue = "NBA-ESUPPORT";
                // }
                if (intent != null && !isNullOrUndefined(window.contactUsDynamicData.resourcesummary[i].insights.verbiage) && window.contactUsDynamicData.resourcesummary[i].insights.verbiage !== "") {
                    nbaCount = nbaCount + 1;
                    let args = {
                        intentCategory: "NBA_DISPLAY",
                        activityCategory: "NBA_DISPLAY",
                        intent: intent,
                        app_n_channel: "NBA-ESUPPORT",
                        os: operatingSystem,
                        pegaSessionID: (!isNullOrUndefined(window.contactUsDynamicData.Attribute) && !isNullOrUndefined(window.contactUsDynamicData.Attribute.content)) ? window.contactUsDynamicData.Attribute.content : "",
                        userid: (this.isValidUser) ? window.userinfo.userId : "",
                        visionID: (this.isValidUser) ? window.userinfo.visionId : "",
                        accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
                    };
                    //   RTCICall(args);
                    if (nbaCount === 2) { break; } // NBA RTCI call will send for two items only in page load
                }
            }
        }
        // Chat();
        // if (this.inputRef.current !== null && this.inputRef.current !== undefined) {
        //     let localInstance = this;
        //     this.inputRef.current.addEventListener("paste", this.pasteActionHandler, true);
        // }
        // let imgBannerLink = document.querySelector('.w_right-section-banner li a');
        // let localInstance = this;
        // imgBannerLink.addEventListener('click', ()=> {
        //     MetricRTCICall(localInstance.metricsArgs);
        //     //makeCall('NewContactUs','ContactOptions','wireless');
        //    // saveMetrics('nc_wireless');
        //     // window.scLinkTrackID('go to wireless');
        // })
        RemoveHeaderHiddenClass();
    }

    onPasteValue(e) {
        e.preventDefault();
        var newValue = this.inputRef.current.value + e.clipboardData.getData("Text");
        if (newValue.length > 10) {
            this.inputRef.current.value = newValue.substring(0, 10);
        }
    }

    getECRMData() {
        this.phoneNumbers = [];
        if (this.props.ECRMData === null || this.props.ECRMData === undefined) { this.phoneNumbers = []; return }
        if (Object.keys(this.props.ECRMData).length === 0 || (Object.keys(this.props.ECRMData).length > 0 && this.props.ECRMData.ecrmStatus !== "success")) {
            this.phoneNumbers = [];
            return
        }
        if (this.props.ECRMData !== null && this.props.ECRMData !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData !== undefined) {
            if (!isNullOrUndefined(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.LookupStatus) && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.LookupStatus.toLowerCase() === "failed") {
                this.phoneNumbers = [];
                return;
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN !== "") {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.CustomerInfo.BTN.toString()));
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN !== undefined) {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.AlternateTN.toString()));
            }
            if (this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo !== undefined && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN !== null && this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN !== undefined) {
                this.phoneNumbers.push(this.changeNUmberIntoMaskFormat(this.props.ECRMData.GetCustomerContactInfoResponse.ResponseData.ContactInfo.MTNInfo.MTN.toString()));
            }
        }
       
       
    }

    changeNUmberIntoMaskFormat(phoneNumber) {
        return "(" + phoneNumber.substring(0, 3) + ") " + phoneNumber.substring(3, 6) + "-" + phoneNumber.substring(6);
    }

    render() {        
        if (this.isValidUser) {
            return (
                <React.Fragment>
                    {/* <ErrorBoundary>
                    <Header/>
                </ErrorBoundary> */}
                    {/* <ErrorBoundary>
                    <NBA pageName="contactus" NBAData={(this.props.DynamicData !== null && this.props.DynamicData !== undefined && this.props.DynamicData.resourcesummary !== undefined) ? this.props.DynamicData.resourcesummary : []}></NBA>
                </ErrorBoundary> */}
                    <section className="contactuspages" id="cu_main" role="region">
                        <div className="container">
                            {/* <ErrorBoundary>
                        <ContactUsBanner HeaderText1={this.props.ContactData.banner[0].bannerTitle} HeaderText2="Find answers. Get in touch" ImageName={this.props.ContactData.banner[0].bannerImage} />
                        </ErrorBoundary>
                        <ErrorBoundary>
                            <CovidAlert/>
                        </ErrorBoundary> */}
                            <div className="row contactus-page" id="callMeSection">
                                <div className="columns call-schedule medium-7 myfios-first_col">
                                    <div className="w_talk-tile">
                                        <div className="w_tile-top-content" id="">
                                            {
                                            !this.IsOneApp && <div className="w_tile-head">
                                                <p id="contactUs" className="contactus" onClick={this.navigateBack.bind(this)}>
                                                    <a className="m_button-back" tabIndex="0" data-track="Contact Us">Contact Us</a>
                                                </p>
                                                <img alt="phone" className="m_phone-icon" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/contact-phone-icon.svg" />
                                                <h2>Schedule a call</h2>
                                            </div>
                                          }
                                            <div className="w_head-content">
                                                <p>Enter a phone number and choose a topic below.</p>
                                                <div className="m_input-field">
                                                    <label>Phone Number</label>
                                                    <div className="phone-numbers">
                                                        {
                                                            this.phoneNumbers.map((item, index) => {
                                                                return <React.Fragment key={item}>
                                                                    <input data-cs-mask type="radio" defaultChecked={(index === 0) ? true : false} className={"m_phone-" + index} id={"radio" + index} tabIndex="0" value={item} />
                                                                    <label htmlFor={"radio" + index} role="radio" aria-checked={(index === 0) ? true : false} aria-required={false} className={(index === 0) ? " checked checkbox" : "checkbox"} onClick={this.toggleCheckBox.bind(this)}>
                                                                        {item}
                                                                    </label>
                                                                    <br />
                                                                </React.Fragment>
                                                            })
                                                        }
                                                        
                                                        <div className='phone-numbers-field' name='phonetxt'>
                                                        <input data-cs-mask type="radio" defaultChecked={(this.phoneNumbers.length > 0) ? false : true} className={"custom_checkbox m_phone-" + this.phoneNumbers.length} id={"radio" + this.phoneNumbers.length} name="" tabIndex="0" />
                                                        <label htmlFor={"radio" + this.phoneNumbers.length} role="radio" className={(this.phoneNumbers.length > 0 ? "checkbox" : "checked checkbox")} aria-checked={(this.phoneNumbers.length > 0) ? false : true} aria-required={false} onClick={this.toggleCheckBox.bind(this)}></label>
                                                        <input data-cs-mask type="number" ref={this.inputRef} className={"custom-phone-input m_phone" + this.phoneNumbers.length} id="custom_number" placeholder="Enter a phone number" tabIndex="0" onKeyDown={this.validateOnKeyDown.bind(this)} onKeyUp={this.validateOnKeyUp.bind(this)} onBlur={this.validatePhoneNumber.bind(this)} />
                                                        </div>
                                                    </div>
                                                    <span className="error"></span>
                                                </div>
                                                <ErrorBoundary>
                                                    <DropDown GID={this.props.globalSessionID} DDlData={this.props.ContactData.callMe[0]} ValidateCheckBox={this.toggleCheckBox.bind(this)} EnableConfirmButton={this.enableConfirmButton} ConformCall={this.updateData.bind(this)} />
                                                </ErrorBoundary>
                                            </div>
                                            <div className="submit_btn">
                                                <a className="submit_button button p-50 disabled" id="callmeButton" tabIndex="0" role="button" onClick={this.scheduleCall.bind(this)} onKeyDown={this.handleConfirmCall.bind(this)} data-track="Confirm">Confirm</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="spinner" className="hide_spinner">
                                    <div data-page-loader className="text-center page-loader text-white active">
                                        <div className="loader small text-center"></div> </div>
                                    <center><img alt="spinner" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/spinner.gif" /></center>
                                </div>
                            </div>
                        </div>
                        <ErrorBoundary>
                            <ModalDialog CloseCallBack={this.closeDialog.bind(this)} DialogRef={this.dialogRef} DialogHeader="We're Sorry" DialogStyle={this.dialogStyle}></ModalDialog>
                        </ErrorBoundary>
                    </section>
                    <ErrorBoundary>
                        <Footer />
                    </ErrorBoundary>
                    <input type="hidden" value="Auth" id="loginType" />
                    <ErrorBoundary>
                        <SiteCatalyst PageDetails={this.props.ContactData.pagedetails} />
                    </ErrorBoundary>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    {console.log('Please login to continue')}
                    <ErrorBoundary>
                        <Header />
                    </ErrorBoundary>
                    <div className="continue-login">Please login to continue with this Page</div>
                    <ErrorBoundary>
                        <Footer />
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <SiteCatalyst PageDetails={this.props.ContactData.pagedetails} />
                    </ErrorBoundary>
                </React.Fragment>
            )
        }
    }
}

export default ContactUsCallMePage


// WEBPACK FOOTER //
// ./src/components/ContactUsCallMePage.js